<template>
  <proa-card>
    <proa-list-group>
      <proa-list-group-item
        v-for="invitedMeeting in invitedMeetings"
        :key="invitedMeeting.id"
        :class="[
          'invited-meeting-container clickable', {
            'active': activeInvitedMeetingId == invitedMeeting.id
          }
        ]"
        @click.native="onClickMeetingRoom(invitedMeeting)"
        @mouseover.native="activeInvitedMeetingId = invitedMeeting.id"
        @mouseleave.native="activeInvitedMeetingId = null"
      >
        <div class="left-flex">
          <div class="meeting-schedule">
            <span>{{ invitedMeeting.startAt | moment('YYYY年MM月DD日（ddd）') }}</span>
            <div class="meeting-schedule-time" :class="{ 'd-inline': $mq !== 'sm' }">
              <span>{{ invitedMeeting.startAt | moment('HH:mm') }}</span>
              〜
              <span>{{ invitedMeeting.endAt | moment('HH:mm') }}</span>
            </div>
          </div>
          <div class="room-name">
            <span v-if="invitedMeeting.getVideoRoomMaster()">{{ invitedMeeting.getVideoRoomMaster().roomName }}</span>
          </div>
          <div class="meeting-title">
            <span>{{ invitedMeeting.meetingTitle }}</span>
          </div>
        </div>
        <div class="enter-room">
          <proa-button
            v-if="invitedMeeting.inDuration"
            @click.native.stop="onClickEnterMeetingRoom(invitedMeeting)"
            @mouseover.native.stop="activeInvitedMeetingId = null"
            variant="primary"
            class="default-button-width"
          >
            {{ $t('common.enterMeetingRoom') }}
          </proa-button>
          <proa-button
            v-else-if="invitedMeeting.isWaitable()"
            @click.native.stop="onClickEnterMeetingRoom(invitedMeeting)"
            @mouseover.native.stop="activeInvitedMeetingId = null"
            variant="primary"
            class="default-button-width"
          >
            {{ $t('common.enterWaitingRoom') }}
          </proa-button>
        </div>
      </proa-list-group-item>
      <proa-list-group-item v-if="enableChangeLimit" class="d-flex justify-content-center">
        <span
          @click="$emit('changeLimited', !limited)"
          :class="['limited-accordion', limited ? 'accordion-open' : 'accordion-close' ]"
        />
      </proa-list-group-item>
    </proa-list-group>
  </proa-card>
</template>

<script>
export default {
  name: 'InvitedMeetingsCard',
  props: {
    invitedMeetings: Array,
    enableChangeLimit: Boolean,
    limited: Boolean
  },
  data() {
    return {
      activeInvitedMeetingId: null
    }
  },
  methods: {
    onClickEnterMeetingRoom: function(invitedMeeting) {
      this.$router.push({ name: 'indexRoom', params: { videoRoomMasterId: invitedMeeting.videoRoomMasterId, id: invitedMeeting.id } })
    },
    onClickMeetingRoom: function(invitedMeeting) {
      this.$router.push({ name: 'showMeetingReservations', params: {
        videoRoomMasterId: invitedMeeting.videoRoomMasterId,
        id: invitedMeeting.id,
        returnPath: this.$route.path.slice(1)
      }})
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.proa-list-group-item.invited-meeting-container {
  padding: 15px;

  @include mq(md) {
    padding: 17px 20px;
  }
}

.invited-meeting-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @include mq(md) {
    flex-wrap: wrap;
    align-items: center;
  }

  &.active {
    background-color: $light-gray-color;
  }
  .left-flex {
    flex-wrap: wrap;
    flex-grow: 1;
    max-width: 50%;
    display: flex;
    flex-direction: column wrap;
    align-items: flex-start;
    justify-content: flex-start;

    @include mq(md) {
      max-width: 80%;
      flex-direction: row;
      align-items: center;
    }

    .meeting-schedule {
      &-time {
        margin-top: 5px;

        @include mq(md) {
          margin-top: 0;
        }
      }
    }
    .room-name {
      flex-shrink: 0;
      color: $light-text-color;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 5px 0;
      max-width: 100%;

      @include mq(md) {
        margin: 0 0 0 20px;
        max-width: 20%;
        flex-grow: 0;
      }
    }

    .meeting-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-basis: 100%;

      @include mq(md) {
        flex-basis: 30%;
        flex-grow: 1;
        margin: 0 20px;
      }
    }
  }

  .enter-room {
    flex-grow: 1;
    text-align: right;
    margin-left: 20px;

    @include mq(md) {
      margin-left: 0;
    }
  }
}

.limited-accordion {
  width: 90px;
  height: 35px;
  background: #FFFFFF;
  border: 1px solid $dark-border-color;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: $light-gray-color;
  }

  &::before {
    content:  '';
    width: 10px;
    height: 10px;
    display:  block;
    border-top: solid 1px;
    border-right: solid 1px;

  }

  &.accordion-open::before {
    transform: rotate(135deg);
    margin-bottom: 4px;
  }

  &.accordion-close::before {
    transform: rotate(-45deg);
    margin-top: 4px;
  }
}
</style>
